import * as React from 'react'
import NumberFieldInnerTable from '../../inputs/NumberFieldInnerTable'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const BhpAddition = ({ data, setData }) => {
  const { t } = useLocalize()
  React.useEffect(() => {
    if (
      data.isAdditionForBhpEnabled === false &&
      ('additionForBhp' in data || 'additionForBhpType' in data)
    ) {
      const { additionForBhp, additionForBhpType, ...rest } = data
      setData(rest)
    }
  }, [data])
  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-px-5 tw-pt-3">
      <div className="tw-flex tw-flex-col tw-gap-1">
        <label className="tw-text-content-subtle tw-text-xs">{t('contract.amount')}</label>
        <NumberFieldInnerTable
          innerLabel="PLN"
          placeholder="0,00"
          value={data?.additionForBhp?.toString() || ''}
          onChange={(e) => {
            setData({
              ...data,
              additionForBhp: Number(e.target.value),
            })
          }}
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-1">
        <label className="tw-text-content-subtle tw-text-xs">
          {t('contract.settlement-type')}
        </label>
        <select
          className="tw-border-border-default tw-bg-background-default tw-w-full tw-rounded tw-border tw-px-3 tw-py-2 tw-text-sm"
          value={data?.additionForBhpType ?? 1}
          onChange={(e) => {
            setData({
              ...data,
              additionForBhpType: Number(e.target.value),
            })
          }}
        >
          <option value={1}>{t('contract.monthly')}</option>
          <option value={0}>{t('contract.daily')}</option>
        </select>
      </div>
    </div>
  )
}

export default BhpAddition
